<div
  class="flex w-full min-h-screen bg-surface-ground font-sans overflow-hidden"
>
  <div class="flex-shrink-0 bg-white z-50 shadow-xl h-screen sticky top-0">
    <app-sidebar
      [sidebarTitle]="'Admin Panel'"
      [menuGroups]="adminMenu"
      [moduleLogo]="tenantLogo"
    >
    </app-sidebar>
  </div>
  <div class="flex-1 flex flex-col h-screen overflow-y-auto page-scroll relative">
    <div class="px-8 pb-20">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
